module.exports = __webpack_public_path__ + "img/Bank NTT.fd465a66.png";